import ArrowBackIcon from "@mui/icons-material/ArrowBack";
 import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  let history= useHistory();
  const username = localStorage.getItem("username");
  const clearlocalstorage = ()=>{
    localStorage.clear();
    history.push("/");
  };
  //localStorage.getItem("avatar");
    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children}
        {hasHiddenAuthButtons?(<Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={()=> history.push("/")}>Back to explore        
        </Button>):
        username?(<Stack spacing={2} direction="row"><Avatar alt={username} src={"avatar.png"} /><p>{username}</p><Button onClick={clearlocalstorage}>LOGOUT</Button></Stack> ):
        (<Stack spacing={2} direction="row"><Button variant="text" onClick={()=> history.push("/login")}>LOGIN</Button>
        <Button variant="contained" onClick={()=> history.push("/register")}>REGISTER</Button>        
        </Stack>)}
      </Box>
    );
};

export default Header;
{/* <p>username</p><Button variant="contained" onClick={clearlocalstorage}>LOGOUT</Button> */}
